import {Routes} from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {OrderComponent} from "./order/order.component";
import {AdminComponent} from "./admin/admin.component";
import {Guard} from "./Guard";
import {AdminLogin} from "./admin/adminLogin.component";
import {paymentSuccess} from "./payment/paymentSuccess.component";
import {paymentFailure} from "./payment/paymentFailure.component";
import {RegistrationComponent} from "./registration/registration.component";
import {PersonalCabinetComponent} from "./personal-cabinet/personal-cabinet.component";
import {PersonalCabinetGuard} from "./PersonalCabinetGuard";
import {QrComponent} from './qr/qr.component';
import {MaintenanceComponent} from './maintenance/maintenance.component';
import {MaintenanceGuard} from './MaintenanceGuard';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [MaintenanceGuard]
  },
  {
    path: 'qr',
    component: QrComponent,
    canActivate: [MaintenanceGuard]
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: 'order',
    component: OrderComponent
  },

  {
    path: 'admin/login',
    component: AdminLogin,
  },

  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [Guard],

  },
  /**
   * Review
   * Todo:
   * Откуда api на фронте?
   */
  {
    path: 'api/payment/success',
    component: paymentSuccess,
  },
  {
    path: 'api/payment/failure',
    component: paymentFailure,
  },
  {
    path: 'payment/success',
    component: paymentSuccess,
  },
  {
    path: 'payment/failure',
    component: paymentFailure,
  },
  /*{
    path: 'registration',
    component: RegistrationComponent,
  },
  {
    path : 'cabinet',
    component: PersonalCabinetComponent,
    canActivate: [PersonalCabinetGuard],
  },*/
  {
    path: '**',
    redirectTo: 'login'
  },



];



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/app-routing.module.ts